/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";



const SearchPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [all, setAll] = useState([]);
  const [filter, setFilter] = useState({});
  const { category } = useParams();
  const Sidebar = () => {
    console.log(filter);
    const changefilter = (id) => {
      let selected = filter.selected;
      let find = selected.indexOf(id);

      if (find > -1) {
        selected.splice(find, 1);
      } else {
        selected.push(id);
      }

      setFilter({ selected });
    };

    const handleChange = (event) => {
      // console.log(count);

      var change = event.target.checked ? 1 : -1;
      // console.log(change);
      setCount((prev) => prev + change);
      setFilter({ ...filter, [event.target.name]: event.target.checked });
    };



    return (
      <div className="sidebar" style={{ width: "15%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px 25px",
            textTransform: "uppercase",
            fontWeight: "600",
          }}
        >
          <div>Filters</div>
          <div
            style={{ color: "indigo", cursor: "pointer" }}
            onClick={() => {
              setCount(0);
              setFilter({});
            }}
          >
            Clear All
          </div>
        </div>{" "}
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            categories
          </div>
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="tshirts"
                  checked={filter["tshirts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Tshirts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shirts"
                  checked={filter["shirts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shirts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shorts"
                  checked={filter["shorts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shorts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shoes"
                  checked={filter["shoes"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shoes</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="kurtas"
                  checked={filter["kurtas"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Kurtas</span>
              </label>
            </li>
          </ul>
        </div>
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Brand
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox"
                  name="red tape"
                  checked={filter["red tape"]}
                  onChange={(e) => handleChange(e)}
                /> Red Tape
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="sassafras"
                  checked={filter["sassafras"]}
                  onChange={(e) => handleChange(e)}
                /> SASSAFRAS
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="nike"
                  checked={filter["nike"]}
                  onChange={(e) => handleChange(e)}
                /> Nike
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="adidas"
                  checked={filter["adidas"]}
                  onChange={(e) => handleChange(e)}
                /> Adidas
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="tommy hilfiger"
                  checked={filter["tommy hilfiger"]}
                  onChange={(e) => handleChange(e)}
                /> Tommy Hilfiger
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="hrx"
                  checked={filter["hrx"]}
                  onChange={(e) => handleChange(e)}
                /> HRX by Hrithik Roshan
              </label>
            </li>
            <li>
              <label>

                <input type="checkbox"
                  name="calvin klein"
                  checked={filter["calvin klein"]}
                  onChange={(e) => handleChange(e)}
                /> Calvin Klein
              </label>
            </li>
          </ul>
        </div>
        {/* <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Price
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> Rs. 199 to Rs. 1149
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 1149 to Rs. 2099
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 2099 to Rs. 3049
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 3049 to Rs. 3999
              </label>
            </li>
          </ul>
        </div> */}
        {/* <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Discount Range
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" 
                checked={filter["10%"]}
                onChange={(e) => handleChange(e)}
                /> 10% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" 
                checked={filter["20%"]}
                onChange={(e) => handleChange(e)}
                /> 20% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" 
                checked={filter["30%"]}
                onChange={(e) => handleChange(e)}
                /> 30% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                checked={filter["40%"]}
                onChange={(e) => handleChange(e)}
                /> 40% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" 
                checked={filter["50%"]}
                onChange={(e) => handleChange(e)}
                /> 50% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                checked={filter["60%"]}
                onChange={(e) => handleChange(e)}
                /> 60% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                checked={filter["70%"]}
                onChange={(e) => handleChange(e)}
                /> 70% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                checked={filter["80%"]}
                onChange={(e) => handleChange(e)}
                /> 80% and above
              </label>
            </li>
          </ul>
        </div> */}
      </div>
    );
  };

  useEffect(() => {
    axios.get("/api/products").then((res) => {
      setTimeout(() => {
        console.log(res.data);
        setProducts((prev) => res.data);
        setAll((prev) => res.data);
        if (count > 0) {
          var filteredProducts = [];
          var filters = [];
          Object.entries(filter).map((entry) => {
            let key = entry[0];
            let value = entry[1];
            if (value === true) filters.push(key);
          });
          console.log(filters);

          all.forEach((product) => {
            if (filters.includes((product.pCategory.cName).toLowerCase()) || filters.includes((product.pName).toLowerCase())) {
              filteredProducts.push(product);
            }
          });
          console.log(filteredProducts, count);
          setProducts((prev) => filteredProducts);
        }
      }, 100);
      setLoading(false)
      // console.log(products);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);



  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "black",
  };

  if (products.length === 0)
  return (
    <>
      <Navbar />
      <div className="Search">
        <h1>We couldn't find any matches!</h1>
        <p style={{ color: "grey", marginBlock: "20px", fontSize: "18px" }}>
          Please check the spelling or try searching something else
        </p>
        <div style={{ marginTop: "50px" }}>
          {/* eslint-disable-next-line */}
          <img src="https://constant.myntassets.com/web/assets/img/11488523304066-search404.png"></img>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Navbar />
      <div className="men" style={{ marginTop: "6rem" }}>
        <div style={{ display: "flex" }}>
          <Sidebar></Sidebar>
          {loading ?
            <div className="main-Content-1" style={{ width: "85%" }}>
              <ClipLoader
                // color={color}
                loading={loading}
                cssOverride={override}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            :
            <div className="main-Content-1" style={{ width: "85%" }}>
              {products &&
                products
                  .filter(function (product) {
                    console.log(product._id);
                    return (product.pType).toLowerCase() === category;
                  })
                  .map((product) => (
                    <div className="inner CC">
                      <div class="productRatingsContainer">
                        <span>4.7</span>
                        <span class="myntraweb-sprite starIcon index-productRatingsGoodIcon RatingsGoodIcon"></span>
                        <div class="ratingsCount">
                          <div class="separator">|</div>15.7k
                        </div>
                      </div>
                      <Link
                        to={`/product/${product._id}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <div className="content">
                          <img
                            src={`/uploads/products/${product.pImages[0]}`}
                            className="card-img-top"
                            alt="..."
                          />
                          <div className="card-body">
                            <h6
                              className="card-title"
                              title={`${product.pName}`}
                              style={{ textAlign: "start", marginBottom: "5px" }}
                            >
                              {product.pName}
                            </h6>
                            <p className="brand-name">{product.pDescription}</p>
                            <h6 className="brand-name">
                              <span>
                                <strong>₹{Math.floor(product.pPrice * (100 - product.pOffer) / 100)}</strong>
                              </span>
                              <span style={{ fontWeight: 400, marginLeft: "8px", fontSize: "12px", opacity: "0.8", lineHeight: 1.2 }}>
                                <s>Rs.{product.pPrice}</s>
                              </span>
                              <span style={{
                                marginLeft: "8px", fontSize: "12px", fontWeight: 500,
                                letterSpacing: ".5px",
                                color: "#ff905a"
                              }}>
                                ({product.pOffer}% OFF)
                              </span>
                            </h6>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default SearchPage;
